module.exports = __webpack_public_path__ + "static/img/stephenson-sam.1aeca59.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stephenson-sam.jpg
// module id = V1Af
// module chunks = 0